const initialState = {
    isOpen: true,
};

export default function sidebar(state = initialState, action = {}) {
    switch (action.type) {
        case 'OPEN_LOG_UNSCHEDULED_CALL_WIZARD':
        case 'OPEN_WIZARD_TO_LOG_INCOMING_CALL':
        case 'OPEN_WIZARD_TO_LOG_SCHEDULED_CALL':
        case 'OPEN_WIZARD_TO_UPDATE_SCHEDULED_CALL':
        case 'OPEN_WIZARD_TO_SCHEDULE_MEETING':
        case 'OPEN_WIZARD_TO_SCHEDULE_CALL':
            return {
                ...state,
                isOpen: false
            };
        case 'TOGGLE_SIDEBAR_OPEN':
            return {
                ...state,
                isOpen: ! state.isOpen
            };
        case 'CLOSE_ACTIVITY_WIZARD':
            return {
                ...state,
                isOpen: true
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/reducers/sidebar.js